import ReactDOM from 'react-dom/client';
import App from 'src/App';
import { ToastContainer } from 'react-toastify';

import 'src/scss/style.scss';
import 'react-toastify/dist/ReactToastify.css';
import { ActiveStepContextProvider } from 'src/components/context/ActiveStepContext';
import { ResidentAvailabilitiesContextProvider } from 'src/components/context/ResidentAvailibilitiesContext';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <ActiveStepContextProvider>
    <ResidentAvailabilitiesContextProvider>
      <App />
      <ToastContainer
        position="bottom-right"
        autoClose={1000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        draggable
        pauseOnHover
        theme="colored"
      />
    </ResidentAvailabilitiesContextProvider>
  </ActiveStepContextProvider>,
);
